import { createReducer } from 'redux-act';

import { getImage, getImageFileName } from '../utils/images';
import { CUSTOMER_MESSAGE_TYPES_MAP } from '../constants/post-box';

import * as actions from '../actions/notifications';

const MESSAGE_TYPES_MAP = {
  ...CUSTOMER_MESSAGE_TYPES_MAP,
  UNKNOWN: 'notification'
};

const DEFAULT_STATE = {
  list: null,
  groupCounts: Object.values(CUSTOMER_MESSAGE_TYPES_MAP).reduce(
    (acc, key) => ({ ...acc, [key]: 0 }),
    { summ: 0 }
  )
};

const mapDoc = ({ file_url, logo_url, text, type }) => {
  return {
    url: file_url,
    fileName: getImageFileName(logo_url),
    icon: getImage(logo_url),
    name: text || ''
  };
};

export default createReducer(
  {
    [actions.notificationsReceived]: (state, notifications) => {
      return {
        ...state,
        list: notifications.map(
          ({
            direction,
            documents,
            datetime,
            channel,
            dateTimeDemonstration,
            agent,
            ...other
          }) => {
            const isClient =
              channel && channel.toUpperCase().startsWith('CLIENT');
            return {
              ...other,
              channel: isClient ? 'CLIENT' : channel,
              type: isClient
                ? MESSAGE_TYPES_MAP.CLIENT
                : MESSAGE_TYPES_MAP[direction],
              mainDoc: documents.length ? mapDoc(documents[0]) : null,
              docs:
                documents.length > 1 ? documents.slice(1).map(mapDoc) : null,
              datetime: dateTimeDemonstration,
              name: agent ? agent.name : null
            };
          }
        ),
        groupCounts: notifications.reduce((acc, { direction }) => {
          return CUSTOMER_MESSAGE_TYPES_MAP[direction]
            ? {
                ...acc,
                [CUSTOMER_MESSAGE_TYPES_MAP[direction]]:
                  acc[CUSTOMER_MESSAGE_TYPES_MAP[direction]] + 1,
                summ: CUSTOMER_MESSAGE_TYPES_MAP[direction]
                  ? acc.summ + 1
                  : acc.summ
              }
            : { ...acc };
        }, DEFAULT_STATE.groupCounts)
      };
    },
    [actions.notificationsReset]: state => {
      return { ...DEFAULT_STATE };
    }
  },
  DEFAULT_STATE
);
